// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"ca49c94f","62":"c6017b0c","170":"9228be66","611":"aa51a380","813":"7df35b90"}[chunkId] + ".chunk.css";
};